import { render } from "./AdvertisingMaterial.vue?vue&type=template&id=1da6039c&scoped=true"
import script from "./AdvertisingMaterial.vue?vue&type=script&lang=js"
export * from "./AdvertisingMaterial.vue?vue&type=script&lang=js"

import "./AdvertisingMaterial.vue?vue&type=style&index=0&id=1da6039c&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da6039c"]])

export default __exports__